<!-- 协议-->
<template>
  <div class="background">
    <div class="agreement">
      <div class="head" style="font-weight: 700; font-size: 16px">
        <label>为了您的照片能尽快通过审批 </label>
        <label>请避免以下情况</label>
      </div>
      <div class="main">
        <div class="main_index">
          <div class="main_itme">
            <img src="../../../static/hunanDIY/组 171.png" />
            <div style="font-size: 13px">
              <label>背景不是白色且标志清晰</label>
            </div>
          </div>
          <div class="main_itme">
            <img src="../../../static/hunanDIY/模糊.png" />
            <div style="font-size: 13px">
              <label>图片不能太模糊</label>
            </div>
          </div>
        </div>
        <div class="main_index">
          <div class="main_item">
            <img src="../../../static/hunanDIY/黄赌毒.png" />
            <div style="font-size: 13px">
              <label>不能涉及黄赌毒</label>
            </div>
          </div>
          <div class="main_item">
            <img src="../../../static/hunanDIY/人像.png" />
            <div style="font-size: 13px">
              <label>不能侵犯他人肖像</label>
            </div>
          </div>
        </div>
        <div class="main_index">
          <div class="main_item">
            <img src="../../../static/hunanDIY/反动.png" />
            <div style="font-size: 13px">
              <label>不含反动的文字或图像</label>
            </div>
          </div>
          <div class="main_item">
            <img src="../../../static/hunanDIY/宗教.png" />
            <div style="font-size: 8px; text-align: center">
              <label>不含宗教、性别等歧视文字或图像</label>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <div style="font-size: 14px; padding: 0 16px 0">
          <b-row>
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <b-col>
              点击确认即为同意<font color="red" @click="showRules_sqxz()"
                >《湖南银行照片卡申请须知》</font
              ><font color="red" @click="showRules_tpgf()"
                >《湖南银行照片卡图片规范》</font
              ><font color="red" @click="showRules_jjk()"
                >《借记卡用卡须知》</font
              ><font color="red" @click="showRules_hnjjk()"
                >《湖南银行借记卡章程》</font
              >
            </b-col>
          </b-row>
        </div>
        <div class="foot_button">
          <b-button
            variant="danger"
            @click="cancelBtn"
            style="width: 140px; height: 46px"
            >取消</b-button
          >
          <b-button
            variant="danger"
            :disabled="disabled"
            @click="confirmBtn"
            style="width: 140px; height: 46px"
            >确认</b-button
          >
        </div>
      </div>
    </div>
    <!-- 湖南银行照片卡申请须知-->
    <b-modal
      ref="rules_sqxz"
      ok-only
      scrollable
      title="湖南银行照片卡申请须知"
      ok-title="确定"
    >
      <div
        style="display: flex; flex-direction: column; justify-content: center"
      >
        <label
          >湖南银行照片卡是一种由持卡人自行选择卡面个性化照片并参与设计的卡片。照片卡是湖南银行借记卡系列产品之一，定位为普卡，其产品功能及服务与湖南银行银联标准人民币普卡相同，具有存取现金、转账汇款、支付结算、消费、理财等功能。照片卡办理各项业务时，均须按照监管机构颁布的有关政策、规定执行。</label
        >
        <label
          >1.申领人须本人申请办理，如实填写个人身份信息等资料且须对所填信息的合法性、真实性、准确性和有效性负责。</label
        >
        <label
          >2.申领人申请照片卡时，应上传符合审核要求的图片作为照片卡卡样图片，具体请详见《湖南银行照片卡图片规范》。</label
        >
        <label
          >3.申领人申请照片卡时，已知晓该借记卡在未激活前仅为空白卡介质，不具备任何银行卡功能。</label
        >
        <label
          >4.湖南银行通过邮寄方式向申领人或申请人选择分支行邮寄照片卡实体卡片，申领人须确保在线申请照片卡时填写的地址、身份信息、联系方式真实、准确和有效，否则将会产生申领人无法收到卡片或卡片激活失败的情形。对此，申领人应自担相关责任。</label
        >
        <label
          >5.申领人收到卡片后，须携带本人有效身份证件及卡片至湖南银行网点办理卡片激活。申领人可申请时查看湖南银行网点地址或拨打湖南银行客服电话96599查询网点地址。</label
        >
        <label
          >6.照片卡作为借记卡系列产品之一，使用规则请参见《湖南银行借记卡章程》《湖南银行借记卡用卡须知》，申领人应仔细阅读上述规则。申领人确保激活照片卡前已经充分阅读和理解上述规则的全部条款和内容，申领人应受上述规则约束。</label
        >
        <label
          >7.照片卡卡片丢失或损坏，可到湖南银行任一营业网点申请补卡/换卡，更换的卡片为银联标准人民币借记卡普卡(标准卡，非照片卡)。如持卡人仍需申领照片卡，可重新提交申请办理。</label
        >
        <label
          >8.湖南银行将按照法律法规规定对申领人个人账户信息严格保密。</label
        >
        <label
          >9.申领人应妥善保管自己借记卡账号及密码，认可湖南银行按照约定方式验证申领人相应资料相符后所形成的交易结果。</label
        >
        <label
          >10.申请卡片优惠期内免费，后期可能需支付相应工本费，具体以湖南银行官方网页展示为准。</label
        >
        <label
          >11.申领人使用湖南银行照片卡如有疑问，可拨打湖南银行客服电话96599咨询。</label
        >
      </div>
    </b-modal>
    <!-- 湖南银行照片卡图片规范-->
    <b-modal
      ref="rules_tpgf"
      ok-only
      scrollable
      title="湖南银行照片卡图片规范"
      ok-title="确定"
    >
      <div
        style="display: flex; flex-direction: column; justify-content: center"
      >
        <label>一、申请人上传的图片需满足以下要求: </label>
        <label
          >为了保证制卡效果，大小应10M以内，横板图片最小为1024*665像素，竖版图片最小为665*1024像素。</label
        >
        <hr />
        <label>二、申请人上传的图片不得包含以下内容:</label>
        <label
          >1.任何与政治相关的，含有鼓吹、煽动、隐喻反政府、反社会、破坏社会公共秩序的文字或图像。</label
        >
        <label>2.任何抵触和违反法律的图片和文字。</label>
        <label
          >3.任何有关损坏个人或集体利益，以及泄漏商业机密、国家机密的文字或图像。</label
        >
        <label>4.任何与宗教信仰有关的、反对或歧视宗教信仰的文字或图像。</label>
        <label>5.任何含有种族、民族歧视、破坏民族团结的文字或图像。</label>
        <label
          >6.任何侵犯他人姓名、肖像、隐私、版权、著作权等权利的文字或图像。</label
        >
        <label>7.任何可能对他人造成侮辱、诽谤或歧视性的文字或图像。</label>
        <label
          >8.任何含有血腥、暴力、色情等令人厌恶或引起他人不安的文字或图像。</label
        >
        <label
          >9.任何未经第三方授权的品牌名称(缩写、简写或与之近似的文字)、商标、LOGO、产品文字图像、广告或者服务以及损害其品牌形象和知名度的文字或图像。</label
        >
        <label>10.未经授权的漫画、插画等。</label>
        <label>11.任何含有广告性质的文字或图像。</label>
        <label
          >12.任何含有容易引发误解的语言、数字、符号和第三方相关服务类电话号码的文字或图像。</label
        >
        <label
          >13.任何含有影响借记卡卡片防伪特征的文字、图像、号码、标志等内容。</label
        >
        <label
          >14.任何含有特殊标志、LOGO的文字或图像(如奥运标志、世界杯标志等)。</label
        >
        <label
          >15.任何包含容易引起商户在受理借记卡卡片时产生误解的文字、图像、号码、LOGO。</label
        >
        <label
          >16.包含身份验证的图片和文字，不得用于照片卡图片(如:身份证、证件照、名片、工作证照、数据指标图样等)。</label
        >
        <label
          >17.任何影响卡片制作清晰效果的图片不得用于照片卡图片(如:抽象类摄影作品、无法明确识别审核要素的照片)。</label
        >
        <label
          >18.含有影响图片审核判断的文字或标识，导致银行无法判别其所含信息的合法性，银行有权拒绝图片审核通过
          (如:各类未经授权于个人使用的组织标识等)。</label
        >
        <label>19.任何不适合作为湖南银行借记卡卡面的文字或图像。</label>
        <hr />
        <label>三、申请人责任</label>
        <label
          >1.申请卡片优惠期内免费，后期可能需支付相应工本费，具体以湖南银行官方网页展示为准。</label
        >
        <label
          >2.申请人上传的图片资料是否符合照片卡照片规范，由湖南银行进行判断，并决定是否受理申请人照片卡的制作申请。无论审核是否通过，申请人授权湖南银行按照法律法规规定对上传的图片资料进行存档、保留或删除。</label
        >
        <label
          >3.申请人上传的图片须为本人或其近亲属（申请人承诺取得其近亲属授权）照片，申请人对上传的图片资料负全部责任。任何因图片使用引发的诉讼等法律纠纷与湖南银行无关，湖南银行有权无条件停止卡片使用，申请人须到湖南银行网点办理相关手续并将卡片交还湖南银行。若湖南银行因此遭受任何损失或损害时，申请人须承担相关法律责任。
        </label>
      </div>
    </b-modal>
    <!--  借记卡用卡须知 -->
    <b-modal
      ref="rules_jjk"
      ok-only
      scrollable
      title=" 借记卡用卡须知"
      ok-title="确定"
    >
      <div
        style="display: flex; flex-direction: column; justify-content: center"
      >
        <label
          >第一条
          我行借记卡是经中国人民银行批准、中国银联核准、由湖南银行（下称“本行”）发行的金融支付工具，具有存取现金、转账结算、消费、理财、电子现金等功能的储蓄卡。该卡属本外币一卡通借记卡，先存后支，不提供透支服务，可在本行各网点及贴有银联标识的机具上使用。</label
        >
        <label
          >第二条 按发行对象不同分为单位商务卡和个人卡。
          凡在本行开立单位基本结算账户并确认遵守《湖南银行借记卡章程》的单位，凭开户证明文件填写开卡申请表格并指定持卡人可向本行申领商务卡。持卡人的资格即由申领单位法定代表人或其委托的代理人书面指定、变更和注销。根据单位的要求商务卡申领张数不限。
          凡自愿遵守《湖南银行借记卡章程》且符合本行发卡条件的个人，均可持本人有效身份证件到本行营业网点申请开立个人卡。个人卡的主卡人可为其配偶及亲属申领附卡，申领的附卡最多二张。主卡人有权要求限制、注销其附卡，主卡对附属卡所产生的交易负责。
        </label>
        <label
          >第三条
          持卡人应按规定使用借记卡，其中商务卡只能用于POS消费，不得转账和存取现金，不得将销售收入存入商务卡，所使用的资金一律记入单位基本结算账户；个人卡可用于现金存取、转账存入、付出款项和POS消费，不得公款私存。
          持卡人办理大额取现业务时，须遵守中国人民银行有关大额现金支付管理的规定。
        </label>
        <label
          >第四条
          申领人申办借记卡，所填写的各项资信数据必须真实合法、有效。开卡时，持卡人应按要求设置6位数字密码，收到卡片后应立即在卡片背面签名栏内签署姓名。</label
        >
        <label
          >第五条
          借记卡具备多储种功能，卡内可开立活期、零存整取、教育储蓄、整存整取、定活两便、通知存款等储蓄账户。</label
        >
        <label
          >第六条
          持卡人凭借记卡和密码可在本行指定的营业机构或金融设备办理存款、取款、转账和理财等业务；可在境内外贴有“银联”标识的自助银行设备办理取款、查询和POS机消费等业务。</label
        >
        <label
          >第七条
          持卡人应设置不规则的密码，以防止被他人破译。批量工资代发的客户在收到借记卡时必须修改初始密码。</label
        >
        <label
          >第八条
          持卡人对借记卡密码要严格保密，不得向他人透露，并定期或不定期更换，防止泄漏。因密码泄漏造成的资金损失，由持卡人自行承担。凡经过密码效验相符的借记卡交易均视为持卡人本人或本人授权的合法交易，本行依据密码为持卡人办理交易所产生的电子信息记录为该项交易的有效凭证。</label
        >
        <label
          >第九条
          持卡人对同一张借记卡，在各种交易渠道连续5次输入交易密码错误，本行有权按有关规定锁定该卡。持卡人可持本人有效身份证件到本行任一网点申请解除锁定，重新开通账户。</label
        >
        <label
          >第十条
          持卡人如遗忘密码，应及时持本人有效身份证件到原开卡行办理密码挂失以及重置手续（无需换卡）。挂失前造成的经济损失，由持卡人自行负责。</label
        >
        <label
          >第十一条
          持卡人应妥善保管借记卡，如被盗或遗失，持卡人可通过拨打客服电话“0731-96599”或就近选择任一网点办理口头挂失，并于口头挂失5日内携带本人有效身份证件到本行任一网点办理书面挂失手续，过期则口头挂失失效。对于挂失生效前发生的资金损失本行不承担责任。
          如在口头挂失后，发卡机构受理书面挂失前又找回原卡，可凭本人有效身份证件向任一网点申请解除口头挂失，恢复使用原卡。
        </label>
        <label
          >第十二条 主卡挂失后其附卡和对应的储蓄账户不能办理取款交易。</label
        >
        <label
          >第十三条
          进行无卡存款时，须准确填写持卡人卡号和姓名，本行以存款人填写的卡号为准入账，因存款人提供错误卡号引起的资金损失由存款人承担。</label
        >
        <label
          >第十四条
          持卡人在存款机（CDM）上存款仅限于规定面额和张数的纸币。存款机打印的存款凭条是交易记录，该种存款方式的存款金额以发卡行实际核定的金额为准，并以对账单中有关发生额为入账依据。</label
        >
        <label
          >第十五条
          持卡人凭借记卡和密码在自助银行设备取现时，境内每卡当日累计金额不超过人民币2万元，境外每卡当日累计金额不超过等值人民币1万元、本人名下所有银行卡（含本行及他行主、附卡）当年累计金额不超过等值人民币10万元。境外取现超过年度限额的，本年及次年将被暂停持境内银行卡在境外提取现金。本行有权根据相关监管政策进行动态调整。</label
        >
        <label
          >第十六条
          持卡人可申请开通电话银行、手机银行、网上银行、ATM转账及银联在线支付等业务。办理电话及ATM转账时，每日每卡转出金额不得超过5万元人民币。持卡人开通银联在线支付业务时，必须预留本人手机号码，不得将借记卡及手机外借他人，不得向他人泄露密码，因银行卡或预留手机遗失、被盗、被抢、密码泄露或持卡人以外的人占用等引起的纠纷和损失由持卡人自行承担。</label
        >
        <label
          >第十七条
          持卡人在自动柜员机上办理业务时，如因终端故障或本人操作原因导致借记卡被吞没，应在吞卡次日起30个工作日内，凭本人有效身份证件和自助银行设备打印的吞卡通知到自助银行设备所属银行网点办理领卡手续。逾期未领回的，自动柜员机所属网点有权作废卡处理。</label
        >
        <label
          >第十八条
          持卡人应妥善保管或处理好存取款回执及刷卡消费回单，不得随意丢放，由此造成的损失由持卡人承担。</label
        >
        <label
          >第十九条
          借记卡存款账户按照中国人民银行和本行相关规定计付利息。</label
        >
        <label
          >第二十条
          借记卡电子现金不记名，电子现金账户不挂失，账户内资金不计息，账户额度上限为人民币1000元。</label
        >
        <label
          >第二十一条
          持卡人在办理借记卡开户、挂失、换卡、跨行存取款等业务时，收取的工本费、手续费以及年费按照人民银行和本行相关规定执行。</label
        >
        <label
          >第二十二条
          持卡人因故终止使用借记卡时，应在结清全部交易款项和有关费用后，持主、附卡到本行各营业机构办理注销手续。对遗失或被盗的借记卡申请销户时，持卡人须在销户前办妥书面挂失手续，挂失期满后才能办理销户。</label
        >
        <label
          >第二十三条
          本行按照公告的收费项目、收费标准、收费方式向持卡人收取服务费用。若持卡人未按公告内容支付费用，本行可中止提供相应服务。收费项目、收费标准、收费方式发生变动时，本行将在相关营业场所公告。持卡人不接受该变动的，可在公告期满次日起20日内办理销户手续。超过此期限仍未办理销户手续的，视为接受。</label
        >
        <label
          >第二十四条
          借记卡仅限于合法持卡人本人使用。持卡人不得将借记卡及网银U盾出租、出借、出售、抵押给他人使用，也不得向他人泄露密码，由此引起的纠纷和损失由持卡人自行承担。</label
        >
        <label
          >第二十五条
          持卡人有权向本行索取最近3个月的对账单。对不符的账务，应在索取对账单之日起10日内进行查询或提出改正要求。</label
        >
        <label
          >第二十六条
          本行对虚假挂失、伪造借记卡、使用伪造或作废借记卡、冒用他人借记卡等对本行造成经济或声誉损失的行为，有权申请保护并依法追究有关当事人的经济责任和法律责任。</label
        >
        <label
          >第二十七条
          借记卡所有权属于本行。如持卡人违反《湖南银行借记卡章程》或国家有关规定，本行可取消持卡人使用借记卡的资格，追回所欠费用，并授权有关银行和特约商户收回借记卡。</label
        >
        <label
          >第二十八条
          持卡人与本行发生争议时，按中华人民共和国有关法律和金融法规予以解决，诉讼管辖地为本行住所地。</label
        >
      </div>
    </b-modal>
    <!--  湖南银行借记卡章程 -->
    <b-modal
      ref="rules_hnjjk"
      ok-only
      scrollable
      title=" 湖南银行借记卡章程"
      ok-title="确定"
    >
      <div
        style="display: flex; flex-direction: column; justify-content: center"
      >
        <label>第一章 总 则</label>
        <label
          >第一条
          为规范湖南银行（下称“本行”）借记卡的发行和使用，依据国务院《储蓄管理条例》和中国人民银行《银行卡业务管理办法》有关规定，结合本行实际，制定本章程。</label
        >
        <label
          >第二条
          本行借记卡是经中国人民银行批准、中国银联核准，由本行发行的，具有存取现金、转账结算、消费、理财、电子现金等功能的储蓄卡。该卡属本外币一卡通借记卡，须先存后支，不提供透支服务。可在中华人民共和国境内及银联指定的其他国家和地区使用。</label
        >
        <label>第三条 申办本行借记卡，无需提供担保。</label>
        <hr />
        <label>第二章 分 类</label>
        <label
          >第四条
          本行借记卡按信息载体不同分为磁条卡、纯芯片卡和复合卡（以下纯芯片卡和复合卡统称IC卡）；按发行对象不同分为单位商务卡和个人卡。
          IC卡在实现金融借记应用（指存取现金、转账结算、消费、理财等储蓄业务）的同时，支持电子现金应用。
          申领商务卡的单位，应在本行开立单位基本结算账户，并凭开户证明文件向本行申领商务卡。可申领多张主卡，但应在申请表上指定持卡人。持卡人的资格由申领单位法定代表人或其委托的代理人书面指定、变更和注销。单位注销基本结算账户的，同时注销所申领的商务卡。
          凡自愿遵守本章程且符合本行发卡条件的个人，均可持本人有效身份证件到本行营业网点申请开立个人卡。个人卡的主卡持卡人可为他人申领附卡，申领的附卡最多二张。主卡持卡人有权要求限制、注销其附卡。
          主卡持卡人对附属卡所产生的交易负责。
        </label>
        <label
          >第五条
          IC卡电子现金不记名，电子现金账户不挂失，账户内资金不计息，账户额度上限为人民币1000元。</label
        >
        <label
          >第六条
          商务卡账户资金一律从其单位基本结算账户转账存入，只能用于消费，不得转账和存取现金，不得将销售收入存入商务卡账户，所有交易款项均记入该单位卡账户。
          个人卡账户的资金包括现金存入或工资性款项、属于个人合法的劳务报酬、投资回报等转账存入等，不得公款私存。持卡人办理大额取现业务时，须遵守中国人民银行有关大额现金支付管理的规定。
        </label>
        <hr />
        <label>第三章 申 领</label>
        <label
          >第七条
          申领人申领本行借记卡时，应按规定填写申请表。申请表所列各项资信数据应真实可靠，经本行发卡网点审查后，符合条件的，准予办理领卡手续。
          批量开卡无起存金额限制。
          持卡人收到卡片后应在卡片背面签名栏内签署姓名。
        </label>
        <label>
          第八条
          持卡人新开卡时须设定6位数密码。个人活期结算账户为该卡的主账户，卡内可开立整存整取、定活两便等储蓄账户为子账户。
          商务卡内资金即为单位基本结算账户资金，开卡时须设定6位数密码，不支持电子现金应用。
        </label>
        <hr />
        <label>第四章 使 用</label>
        <label>第九条 借记卡遵循银行Ⅰ、Ⅱ、Ⅲ类账户的管理及使用。</label>
        <label
          >第十条
          持卡人凭借记卡和密码，可在本行指定的营业机构或金融设备办理存款、取款、转账和理财等业务；可在境内外贴有“银联”标识的自助银行设备办理取款、查询等业务；可在境内外贴有“银联”标识的POS机办理购物消费业务。持卡人可通过电话银行、自助银行、手机银行、网上银行等自助渠道查询账户余额、交易明细和办理金融交易；可办理代缴公用事业费、代发工资等代理业务和经中国人民银行、银保监会批准的其他个人金融业务。</label
        >
        <label
          >第十一条
          持卡人在进行密码设置时，应设置不规则密码，防止被他人破译。持有初始密码的持卡人在取款交易前应修改密码，因密码泄漏造成的资金损失，由持卡人自行承担。</label
        >
        <label
          >第十二条
          持卡人对本行借记卡密码要严格保密，不得向他人透露，并定时更换，防止泄漏。凡通过密码效验的本行借记卡交易均视为持卡人本人或本人授权的合法交易，发卡行依据密码为持卡人办理交易所产生的电子信息记录为该项交易的有效凭证。</label
        >
        <label
          >第十三条
          对同一张本行借记卡，持卡人在各种交易渠道连续5次输入交易密码错误，发卡行有权按有关规定锁定该卡。持卡人可持本人有效身份证件、借记卡到本行任一网点凭原密码解除锁定。</label
        >
        <label
          >第十四条
          本行借记卡账户止付后，止付金额之外的余额持卡人可自由支取。</label
        >
        <label
          >第十五条
          持卡人进行无卡存款时，应准确填写持卡人卡号和姓名。本行以存款人填写的卡号入账，因存款人提供错误卡号引起的资金损失由存款人承担。</label
        >
        <label
          >第十六条
          持卡人可凭卡在发卡营业网点办理存款，也可凭卡按本行规定，在指定的存取款机（CDM）上存款。在CDM机上存款仅限于规定面额和张数的纸币。CDM机打印的存款凭条是交易记录，该种存款方式的存款金额以发卡行实际核定的金额为准，并以对账单中有关发生额为入账依据。</label
        >
        <label
          >第十七条
          持卡人凭本行借记卡和密码在自助银行设备取现时，境内每卡当日累计金额不超过人民币2万元，境外每卡当日累计金额不超过等值人民币1万元、本人名下所有银行卡（含本行及他行主、附卡）当年累计金额不超过等值人民币10万元。境外取现超过年度限额的，本年及次年将被暂停持境内银行卡在境外提取现金。本行有权根据相关监管政策进行动态调整。</label
        >
        <label
          >第十八条
          持卡人在自动柜员机上办理业务时，如因终端故障或本人操作原因导致本行借记卡被吞没，持卡人应在吞卡次日起30个工作日内，凭本人有效身份证件和自助银行设备打印的吞卡通知，到自助银行设备所属银行网点办理领卡手续。逾期未领回的，自动柜员机所属网点有权作废卡处理。</label
        >
        <label
          >第十九条
          持卡人在特约商户购物、消费时，应先在POS上插（刷）卡，待确认交易金额后，由持卡人输入密码，并在打印的POS交易单上签名。</label
        >
        <label
          >第二十条
          商务卡销卡时，只是对卡片进行注销，与其对应的基本结算账户不作账务处理。IC卡销卡时，电子现金及借记应用同时注销。</label
        >
        <hr />
        <label>第五章 挂 失</label>
        <label
          >第二十一条
          持卡人如遗失密码，应及时持本人有效身份证件到本行任一网点办理密码挂失及重置手续（无需换卡）。因密码泄密造成的经济损失，由持卡人负责。</label
        >
        <label
          >第二十二条
          持卡人应妥善保管本行借记卡，如被盗或遗失，持卡人可通过拨打本行客服电话或就近选择本行任一网点申请办理口头挂失。持卡人应于口头挂失后5日内携带本人有效身份证件到本行任一网点办理书面挂失手续。口头挂失过期失效。
          持卡人口头挂失后，如在发卡机构受理书面挂失前找回原卡，可凭本人有效身份证件向本行任一网点申请解除口头挂失，恢复使用原卡。
          挂失办妥后实时生效。持卡人不承担挂失生效后因本行借记卡被冒用所发生的储蓄账户资金损失，但应承担IC卡内电子现金账户资金的损失。挂失生效前发生的资金损失，本行不承担责任。挂失期满后，持卡人应持挂失申请书和本人有效身份证件办理换卡手续，原本行借记卡注销。
        </label>
        <label
          >第二十三条
          主卡挂失后，其附卡和对应的储蓄账户不能办理取款交易，IC卡内电子现金交易不受限制。</label
        >
        <hr />
        <label>第六章 权利和义务</label>
        <label
          >第二十四条
          持卡人办理本行借记卡开户、挂失、换卡、跨行存取款等业务时，应按照中国人民银行和本行相关标准缴纳相应的工本费、手续费以及年费。持卡人在本行营业网点办理存取款业务免收手续费；本地或异地购物、消费无须支付手续费。</label
        >
        <label
          >第二十五条
          本行借记卡因损坏、变形、磁卡记录消失等原因需要更换时，持卡人应持借记卡、本人有效身份证件到本行营业机构办理换卡手续，同时交回原卡，按原户名填写《换卡申请书》，并缴纳工本费。</label
        >
        <label
          >第二十六条
          持卡人终止使用本行借记卡时，应在结清全部交易款项和有关费用后，持主、附卡到本行任一营业机构办理注销手续。销户主卡前应先行注销附卡及卡内子户。遗失或被盗的本行借记卡申请销户时，持卡人应在销户前办妥书面挂失手续，期满后办理销户手续。</label
        >
        <label
          >第二十七条
          本行按照公示的收费项目、收费标准、收费方式向持卡人收取服务费用。若持卡人未按公示内容支付费用，发卡行可中止提供相应服务。收费项目、收费标准、收费方式发生变动时，发卡行按有关规定将变动内容在营业场所公示。持卡人不接受该变动的，可在公示期满次日起20日内办理销户手续。超过此期限仍未办理销户手续的，视为接受。</label
        >
        <label
          >第二十八条
          本行借记卡仅限于合法持卡人本人使用。持卡人不得将本行借记卡及网银U盾出租、出借、出售、抵押给他人使用，也不得向他人泄露密码。持卡人违反前述规定，引发的纠纷和损失由持卡人承担。</label
        >
        <label
          >第二十九条
          持卡人在特约商户购物、消费凭卡结算时，特约商户应严格按银联商务受理银行卡业务协议书规定的受理规程办理。若特约商户违反操作规程受理本行借记卡，由此产生的风险和损失由特约商户承担。</label
        >
        <label
          >第三十条
          本行应向持卡人提供咨询、查询、对账、挂失、投诉等服务。对持卡人关于账户情况的查询和改正要求应于受理后30日内答复。本行对持卡人的资信资料保密（法律另有规定的除外）。</label
        >
        <label
          >第三十一条
          本行不寄送对账单。持卡人对交易提出疑问的，应于受理后30日内答复。持卡人有权向本行索取最近3个月的对账单，对不符的账务应于取得对账单之日起10日内进行查询或提出改正要求。</label
        >
        <label
          >第三十二条
          下列可能对本行造成经济和声誉损失的行为，本行有权申请保护并依法追究有关当事人的经济责任和法律责任：虚假挂失；伪造本行借记卡；使用伪造或作废本行借记卡；冒用他人的本行借记卡等。</label
        >
        <label
          >第三十三条
          由于不可抗力原因导致本行借记卡暂时无法使用的，本行不承担相关责任；由于不可抗力原因导致的账务差错的，本行有权予以纠正。</label
        >
        <label
          >第三十四条
          本行借记卡所有权属于本行。如持卡人违反国家有关规定或本章程，本行可取消持卡人使用本行借记卡的资格，追回所欠费用，并授权有关银行和特约商户收回本行借记卡。</label
        >
        <label
          >第三十五条
          持卡人与本行发生争议时，按中华人民共和国有关法律和金融法规予以解决，诉讼管辖地为本行注册地。</label
        >
        <hr />
        <label>第七章 计 息</label>
        <label
          >第三十六条
          本行借记卡账户存款按照中国人民银行规定的同期同档次的存款利率和计息办法计付利息，按照国家规定的税率由发卡行代扣代缴储蓄存款利息所得个人所得税。</label
        >
        <hr />
        <label>第八章 附 则</label>
        <label
          >第三十七条
          因持卡人违反国家相关法律、法规、规章或本章程的规定，本行有权随时停止向持卡人提供相应服务。本行因其他原因停止持卡人使用借记卡，应在营业网点或银行网站提前通知持卡人。</label
        >
        <label
          >第三十八条
          因供电、通讯、系统故障等原因导致持卡人用卡受阻的，本行可视情况协助持卡人解决问题或提供必要的帮助，但不承担因此可能给持卡人造成的损失。</label
        >
        <label
          >第三十九条
          本行以合法方式（包括但不限于营业网点或网站公告）发布的、在持卡人用卡期间持续有效的公告（包括领取借记卡之前和之后发布的），均同样适用于持卡人。公告内容与本章程不一致的，以发布在后的为准。</label
        >
        <label>第四十条 本章程由湖南银行制定、修订和解释。</label>
        <label>第四十二条 本章程自2022年11月28日起施行。</label>
      </div>
    </b-modal>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
export default {
  name: "Agreement",
  props: {},
  data() {
    return {
      status: "not_accepted",
      disabled: true,
      bankSerialNumber: "",
      modifyPicture: "", //是否为修改图片（1：申请，2：修改）
    };
  },
  methods: {
    // 取消按钮
    cancelBtn() {
      wx.miniProgram.navigateBack({
        delta: 1,
      });
    },
    // 确定按钮
    confirmBtn() {
      this.$router.replace({
        name: "ApplyForCard",
        params: {
          bankSerialNumber: this.bankSerialNumber,
          modifyPicture: this.modifyPicture,
        },
      });
    },
    showRules_sqxz: function () {
      this.$refs["rules_sqxz"].show();
    },
    showRules_tpgf: function () {
      this.$refs["rules_tpgf"].show();
    },
    showRules_jjk: function () {
      this.$refs["rules_jjk"].show();
    },
    showRules_hnjjk: function () {
      this.$refs["rules_hnjjk"].show();
    },
  },
  watch: {
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  mounted: function () {
    this.bankSerialNumber = this.$route.query.bankSerialNumber;
    console.log("bankSerialNumber--->", this.bankSerialNumber);
    this.modifyPicture = this.$route.query.modifyPicture;
    console.log("bankSerialNumber--->", this.modifyPicture);
  },
};
</script>
<style scoped>
.background {
  width: 100%;
  height: 120%;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 16px 16px 16px 16px;
}
.agreement {
  background-color: white;
  border-radius: 10px;
  padding: 10px 10px 20px 10px;
}
.head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.main_index {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 0 10px;
}
.foot_button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/hunanbank/Agreement.vue